import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { isFramed } from 'utils/iframe';

const getYPositionOfTopOfIframe = () => {
  const element = window.top.document.querySelector('.planner-iframe');
  if (element) {
    const rect = element.getBoundingClientRect();
    return rect.top + window.top.scrollY - window.top.document.documentElement.clientTop;
  }
  return 0;
};

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location && !this.props.cwcalcReachedFromUpptacka) {
      window.scrollTo(0, 0);
    }
    if(isFramed && this.props.location !== prevProps.location && !this.props.cwcalcReachedFromUpptacka){
      window.top.scrollTo(0, getYPositionOfTopOfIframe());
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node,
};

ScrollToTop.defaultProps = {
  children: null,
};

export default withRouter(ScrollToTop);
